class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    const potionsSection = this.querySelector('[data-reco-noid]');
    if (potionsSection) {
      const recoValue = potionsSection.getAttribute('data-reco-noid');
      potionsSection.removeAttribute('data-reco-noid');
      potionsSection.setAttribute('data-reco-id', recoValue);
      console.log('[Potions Cart] data-reco-noid transformed to data-reco-id:', recoValue);
    }

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      // Défini par potions-cart-refresh.js (absent si les recos sont désactivées).
      if (typeof reloadPotionsScript === 'function') reloadPotionsScript();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // Re-synchronise le tiroir et la bulle du header avec l'état réel du panier
  // (page restaurée depuis le cache arrière/avant après un ajout sur une PDP).
  refreshFromServer() {
    const url = `${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`;
    return fetch(url)
      .then((response) => response.json())
      .then((sections) => {
        const drawerSection = this.getSectionDOM(sections['cart-drawer'], '#CartDrawer');
        const bubbleSection = this.getSectionDOM(sections['cart-icon-bubble']);
        if (!drawerSection || !bubbleSection) return;

        const isEmpty = drawerSection.querySelector('cart-drawer-items')?.classList.contains('is-empty') ?? false;
        this.classList.toggle('is-empty', isEmpty);

        document.getElementById('CartDrawer').innerHTML = drawerSection.innerHTML;
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) bubble.innerHTML = bubbleSection.innerHTML;

        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        if (typeof reloadPotionsScript === 'function') reloadPotionsScript();
      })
      .catch((error) => console.error('[cart-drawer] refresh after back navigation failed', error));
  }
}

customElements.define('cart-drawer', CartDrawer);

// Retour arrière/avant : le navigateur restaure la page telle qu'elle était,
// donc le panier affiché ne reflète pas un ajout fait sur la page quittée.
window.addEventListener('pageshow', (event) => {
  const navigation = performance.getEntriesByType('navigation')[0];
  const isBackForward = event.persisted || navigation?.type === 'back_forward';
  if (!isBackForward) return;
  document.querySelector('cart-drawer')?.refreshFromServer();
});

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
